export default __webpack_public_path__ + "static/media/weathericons-regular-webfont.e4d2c00e.woff";